export const getFormDataState = (appSettingsFlags = null) => ({
  maintenanceFlag: {
    value: appSettingsFlags ? appSettingsFlags.maintenanceFlag : null,
    isValid: true,
  },
  adminJob: {
    value: null,
    isValid: true,
  },
  isInitialised: !!appSettingsFlags,
});
